import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
import { landingPageEscritorio } from '@ibk/shared-assets';
import { HeroLayout } from '@ibk/shared-layout';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { Icon } from '@ibk/shared-ui';
import { BenefitsLandingContent } from '../../components/BenefitsLandingContent';
import { beneficiosTranslations } from '../../translations';
import { NetworkPage } from '../NetworkPage';
import styles from './components/NetworkLink.module.css';
function LandingPageAccountingContent({ heroImage = landingPageEscritorio, onContract, onInviteClients, }) {
    const { t } = useTranslation();
    const [isNetworkModalOpen, setIsNetworkModalOpen] = useState(false);
    const accountingFeatures = [
        {
            icon: _jsx(Icon, { name: 'recharge' }),
            title: t('benefits.landing.features.dominio-integration.title'),
            description: t('benefits.landing.features.dominio-integration.description'),
        },
        {
            icon: _jsx(Icon, { name: 'currency' }),
            title: t('benefits.landing.features.single-card-balances.title'),
            description: t('benefits.landing.features.single-card-balances.description'),
        },
        {
            icon: _jsx(Icon, { name: 'food' }),
            title: t('benefits.landing.features.accredited-network.title'),
            description: t('benefits.landing.features.accredited-network.description'),
        },
        {
            icon: _jsx(Icon, { name: 'listCheck' }),
            title: t('benefits.landing.features.zero-cost.title'),
            description: t('benefits.landing.features.zero-cost.description'),
        },
        {
            icon: _jsx(Icon, { name: 'featureIsencao' }),
            title: t('benefits.landing.features.charge-exemption.title'),
            description: t('benefits.landing.features.charge-exemption.description'),
        },
        {
            icon: _jsx(Icon, { name: 'featureSeguranca' }),
            title: t('benefits.landing.features.legal-security.title'),
            description: t('benefits.landing.features.legal-security.description'),
        },
        {
            icon: _jsx(Icon, { name: 'featureComodidade' }),
            title: t('benefits.landing.features.digital-account.title'),
            description: t('benefits.landing.features.digital-account.description'),
        },
        {
            icon: _jsx(Icon, { name: 'featureVantagens' }),
            title: t('benefits.landing.features.exclusive-advantages.title'),
            description: t('benefits.landing.features.exclusive-advantages.description'),
        },
    ];
    const handleContractClick = useCallback(() => {
        if (onContract) {
            onContract();
        }
        else {
            console.log('Contract button clicked - LandingPageAccounting');
        }
    }, [onContract]);
    const handleInviteClientsClick = useCallback(() => {
        if (onInviteClients) {
            onInviteClients();
        }
        else {
            console.log('Invite clients button clicked - LandingPageAccounting');
        }
    }, [onInviteClients]);
    const handleOpenNetworkModal = useCallback(() => {
        setIsNetworkModalOpen(true);
    }, []);
    const handleCloseNetworkModal = useCallback(() => {
        setIsNetworkModalOpen(false);
    }, []);
    return (_jsxs(HeroLayout, { heroImage: heroImage, variant: 'accounting', heroText: {
            title: t('benefits.landing.hero.title'),
            subtitle: t('benefits.landing.hero.subtitle-escritorio'),
            titleFirstWordBold: true,
        }, children: [_jsx(BenefitsLandingContent, { title: t('benefits.landing.title'), features: accountingFeatures, titleCentered: true, actions: {
                    primaryButton: {
                        text: t('benefits.landing.actions.contract-button'),
                        onClick: handleContractClick,
                    },
                    secondaryButton: {
                        text: t('benefits.landing.actions.invite-clients-button'),
                        onClick: handleInviteClientsClick,
                    },
                    showSeparator: true,
                    separatorText: t('benefits.landing.actions.separator'),
                }, networkLink: _jsxs("button", { onClick: handleOpenNetworkModal, className: styles.networkLink, "data-testid": 'landing-network-link', children: [_jsx(Icon, { name: 'store', className: styles.networkLinkIcon }), _jsx("span", { children: t('benefits.landing.viewNetwork') })] }) }), _jsx(NetworkPage, { isOpen: isNetworkModalOpen, onClose: handleCloseNetworkModal, "data-testid": 'NetworkModal' })] }));
}
export const LandingPageAccounting = props => {
    return (_jsx(TranslationProvider, { translations: beneficiosTranslations, defaultLanguage: 'pt-BR', children: _jsx(LandingPageAccountingContent, { ...props }) }));
};
